export default {
  init() {
    // Isotope layout for team list
    var $grid = $('.about-team .row').imagesLoaded(function() {
      $grid.isotope({
        layoutMode: 'fitRows',
      });
    });

    // Filter team list by selected category
    $('.about-team-categories').on('click', 'a', function() {
      var filterValue = $(this).attr('data-filter');
      $grid.isotope({ filter: filterValue });

      $('.about-team-categories a').removeClass('active');
      $(this).addClass('active');
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/about.js